import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Eyebrow } from '@web/atoms';
import { ResponsiveImage } from '@web/molecules';
import { Footer } from '../Footer';
import { useReporter } from '../../reporter';
import {
  userViewsOnboardingInterstitial,
  userContinuesFromInterstitial,
} from '../events';
import {
  StyledOnboardingInterstitial,
  ImageContainer,
  Headline,
  Subheadline,
} from './styles.js';

export const OnboardingInterstitial = ({
  goBack,
  onSubmit,
  eyebrowText,
  image,
  headline,
  subheadline,
  previousQuestion = '',
}) => {
  const reporter = useReporter();
  const viewPageTagFired = useRef(false);
  useEffect(() => {
    if (!viewPageTagFired.current) {
      reporter.tag(userViewsOnboardingInterstitial(previousQuestion));
      viewPageTagFired.current = true;
    }
  }, [reporter, previousQuestion]);
  const handleSubmit = () => {
    reporter.tag(userContinuesFromInterstitial(previousQuestion));
    onSubmit();
  };

  return (
    <>
      <StyledOnboardingInterstitial>
        {eyebrowText && (
          <Eyebrow marginBottom={1} textAlign={'center'}>
            {eyebrowText}
          </Eyebrow>
        )}
        <Headline>{headline}</Headline>
        <ImageContainer>
          <ResponsiveImage
            src={image.src}
            alt={image.alt}
            width={300}
            height={300}
          />
        </ImageContainer>
        <Subheadline>{subheadline}</Subheadline>
        <Footer
          onBackButtonClick={goBack}
          onForwardButtonClick={handleSubmit}
        />
      </StyledOnboardingInterstitial>
    </>
  );
};
OnboardingInterstitial.displayName = 'OnboardingInterstitial';
OnboardingInterstitial.propTypes = {
  image: PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
  headline: PropTypes.string.isRequired,
  subheadline: PropTypes.node,
  eyebrowText: PropTypes.string,
  goBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  previousQuestion: PropTypes.string,
};
